import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { debugLogs } from "repoV2/features/Common/modules/DebugLogs/utils/Logs.utils";
import { logError } from "repoV2/utils/common/error/error";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import { callGetLoyaltyAndPromoDetailsApi } from "./apis/LoyaltyAndPromoDetailsApi/LoyaltyAndPromoDetailsApi";
import { ICoupon } from "./apis/LoyaltyAndPromoDetailsApi/ILoyaltyDiscountSectionApi.interface";

const useGetLoyaltyAndPromoDetails = ({
    hostName,
    listingUuid,
}: {
    hostName: string;
    listingUuid: string;
}) => {
    const [loyaltyData, setLoyaltyData] = useState<{
        showLoyalty: boolean;
        promotionalCoupons: ICoupon[];
    }>({
        showLoyalty: false,
        promotionalCoupons: [],
    });

    const priceDetails =
        useSelector(
            (state: IRepoV2ReduxState) =>
                state.checkoutPages.listingDetails[listingUuid]?.priceSection
        ) || {};

    const { isFetched: isPriceDetailsFetched, data: priceData } = priceDetails;

    const { currency_name: currencyName = "" } = priceData || {};

    const fetchLoyaltyAndPromoDetails = async () => {
        try {
            const {
                show_loyalty: showLoyalty,
                promotional_coupons: promotionalCoupons,
            } = await callGetLoyaltyAndPromoDetailsApi({
                hostName,
                listingUuid,
                currencyName,
            });

            setLoyaltyData({ showLoyalty, promotionalCoupons });
        } catch (error) {
            debugLogs({
                data: {
                    call: "calling the checkout basic details, section 9 for loyalty codes",
                    hostName,
                    listingUuid,
                    href: window.location.href,
                },
                metaData: {},
            });
            logError({
                error,
                when: "calling loyalty and promo details API",
                occuredAt:
                    "repoV2/features/CheckoutPages/utils/useGetLoyaltyAndPromoDetails.ts",
            });
        }
    };

    useEffect(() => {
        if (isPriceDetailsFetched) {
            fetchLoyaltyAndPromoDetails();
        }
    }, [isPriceDetailsFetched]);

    return loyaltyData;
};

export default useGetLoyaltyAndPromoDetails;
